module.exports = __webpack_public_path__ + "img/edu-background.4e84bfa.jpg";